import React from "react";
import { useNavigate } from "react-router-dom";
import { UploadCloud } from "lucide-react";
import OnboardingLayout from "@/components/OnboardingLayout";
import PlaybookEditor from "@/components/PlaybookEditor";
import { useBusiness } from "@/context/BusinessContext";

export function OnboardingPlaybook() {
  const { active, loading } = useBusiness();
  const nav = useNavigate();
  const [pb, setPb] = React.useState(null);

  React.useEffect(() => {
    if (!loading && !active) nav("/onboarding/business", { replace: true });
  }, [loading, active, nav]);
  if (loading || !active) return null;

  return (
    <OnboardingLayout current="playbook" title="Define Wappy's skills" sidebar={pb?.rail}
      secondaryAction={pb && !pb.viewingVersion ? { label: "Save draft", onClick: pb.saveDraft, loading: pb.saving, variant: "default", testId: "pb-footer-save" } : undefined}
      primaryAction={pb && !pb.viewingVersion ? { label: "Publish", onClick: pb.publish, loading: pb.publishing, disabled: !pb.hasText, testId: "pb-footer-publish", icon: <UploadCloud size={15} /> } : undefined}>
      <PlaybookEditor businessId={active.id} withRail={false} hideActions onState={setPb} />
    </OnboardingLayout>
  );
}

export function PlaybookPage() {
  const { active, loading } = useBusiness();
  if (loading) return null;
  if (!active) return <div className="text-sm" style={{ color: "var(--text-muted)" }}>Create a workspace first.</div>;
  return <PlaybookEditor businessId={active.id} />;
}
